$(document).ready(function () {
    // 显示返回会议按钮
    var meetingId = common.getCookie('isJoinMeeting');
    var $livingIcon = $('.assist-side-living');
    if(meetingId) {
        $livingIcon.show();
        $livingIcon.click(function () {
            window.location.href = solution_host + '/meeting/live.html?webinarId='+ meetingId +'&isLive=true';
        });
    }
});